import { FieldSchema } from '@/modules/dynamic-form/models/FieldSchema.model';
import { FieldValidator } from '@/modules/dynamic-form/models/FieldValidator.model';
import { ValidationRules } from '@/modules/dynamic-form/models/ValidationRuleNames.model';
import { createDateValidators } from '@/modules/dynamic-form/validations/date/createDateValidators';
import { createStrValidators } from '@/modules/dynamic-form/validations/str/createStrValidators';

export function createDefaultValidators(
    schema: FieldSchema,
    customMessages?: Record<ValidationRules, string>,
): FieldValidator[] {
    const validators: FieldValidator[] = [];
    if (schema.type.$type === 'String') {
        validators.push(...createStrValidators(schema.label, schema.type, customMessages));
    } else if (schema.type.$type === 'Date') {
        validators.push(...createDateValidators(schema.label, customMessages));
    }
    return validators;
}
